import React, { memo } from "react";
import ReactSelect, { Props, StylesConfig } from "react-select";
import { generalSelectStyle } from "./general.styles";
export interface SelectProps extends Props {
  // eslint-disable-next-line
  style?: StylesConfig<any, any, any>;
  isBorder?: boolean,
  components?: any;
}

// eslint-disable-next-line
const Select = React.forwardRef<any, SelectProps>((props: SelectProps, ref) => {
  const defaultPortalTarget =
    typeof document !== "undefined" ? document.body : undefined;
  // Allow callers to disable portaling (e.g. mobile/Instagram WebView) via null
  const menuPortalTarget =
    props.menuPortalTarget !== undefined
      ? props.menuPortalTarget
      : defaultPortalTarget;
  const menuPosition =
    props.menuPosition ?? (menuPortalTarget ? "fixed" : "absolute");

  return (
    <ReactSelect
    styles={{
      ...generalSelectStyle, ...(props?.style ?? {}), menuPortal: provided => ({ ...provided, zIndex: 9999 }), menu: provided => ({ ...provided, zIndex: 100000 }), control: (baseStyles, state) => ({
        ...baseStyles,
        border: props.isBorder ? "1px solid #989898" : "none",
        boxShadow: 'none',
      }),
    }}
    {...props}
    components={props.components}
    ref={ref}
    menuPortalTarget={menuPortalTarget}
    menuPosition={menuPosition}
  />
  );
});
export default memo(Select);
